import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "../ui/textarea";
import { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function sendEmail() {
    if (loading) return;
    setLoading(true);
    const serviceId = "service_24ce837";
    const templateId = "form-query";
    const templateParams = {
      company,
      from_email: email,
      from_name: firstName + " " + lastName,
      message,
    };
    try {
      const response = await emailjs.send(
        serviceId,
        templateId,
        templateParams
      );
      if (response.status === 200) {
        setLoading(false);
        setSent(true);
        setEmail("");
        setCompany("");
        setFirstName("");
        setLastName("");
        setMessage("");
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  useEffect(() => emailjs.init("R3d0I_yr5Gc9RKl1U"), []);

  return (
    <section id="contact" className="mb-20 px-5 md:px-0 md:mb-40">
      {/* banner */}
      {/* <div className="flex flex-col items-center justify-center h-[360px] px-4 mb-20 rounded-[3rem] md:mb-40 bg-[#5263FF] relative">
        <div className="bg-[url('../assets/blob.svg')] bg-repeat-space absolute inset-0 translate-y-44 translate-x-36 " />
        <div className="bg-[url('../assets/blob.svg')] bg-repeat-space absolute inset-0 rotate-180 -translate-y-44 -translate-x-32 " />
        <h6 className="max-w-4xl mb-10 text-3xl font-bold text-center text-white uppercase lg:text-5xl">
          Get started with ELOOP
        </h6>
        <Button className="px-8 z-50" variant={"secondary"}>
          Get in touch
        </Button>
      </div> */}

      {/* form */}
      <div className="flex flex-col items-center">
        <h4 className="mb-6 text-3xl font-bold text-center uppercase md:mb-8 md:text-5xl">
          Get in touch
        </h4>
        <div className="flex flex-col w-full grid-cols-2 gap-2 mb-2 md:grid">
          <Input
            value={company}
            onChange={(e) => {
              setSent(false);
              setCompany(e.target.value);
            }}
            placeholder="Company"
          />
          <Input
            value={email}
            onChange={(e) => {
              setSent(false);
              setEmail(e.target.value);
            }}
            placeholder="Email"
          />
          <Input
            value={firstName}
            onChange={(e) => {
              setSent(false);
              setFirstName(e.target.value);
            }}
            placeholder="First name"
          />
          <Input
            value={lastName}
            onChange={(e) => {
              setSent(false);
              setLastName(e.target.value);
            }}
            placeholder="Last name"
          />
          <Textarea
            value={message}
            onChange={(e) => {
              setSent(false);
              setMessage(e.target.value);
            }}
            className="col-span-2"
            placeholder="How can we help?"
          />
        </div>
        <Button onClick={() => sendEmail()} className="px-20 bg-[#5263ff]">
          {sent ? "Message Sent!" : loading ? "Sending..." : "Send"}
        </Button>
      </div>
    </section>
  );
}
